import { useState } from 'react'
import { useCreatePermission, useFetchPermissions } from '../../../hooks/api'

const usePermissionsLogic = () => {
  const [filters, setFilters] = useState<Filters>({
    pageSize: 10,
    searchTerm: '',
    pageNumber: 1,
  })
  const handleSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((prev) => ({ ...prev, searchTerm: e.target.value }))
  }
  const fetchAllPermissions = useFetchPermissions(filters)
  const createNewPermissions = useCreatePermission()
  return { createNewPermissions, fetchAllPermissions, handleSearchTerm }
}
export default usePermissionsLogic
